import cx from 'classnames'
import type React from 'react'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
// @TODO review this and fix
// @ts-expect-error - Module has no exported member 'BlockItem'
import type { BlockItem } from '@/types/models'
import { SearchEntity } from '../../hooks/useSearch'
import css from '../../Result.module.scss'

type Props = {
  blocks: Record<string, BlockItem>
  selectedItemId: string | null
  onClick: (entity: SearchEntity, payload: any) => void
  hideTitle?: boolean
}

const BlockNotes: React.FC<Props> = ({
  blocks,
  selectedItemId,
  onClick,
  hideTitle,
}) => {
  const handleClick = (block: BlockItem) => () => {
    sendGtmEvent(
      GtmTriggerName.SEARCH_RESULT_CLICK,
      'Block note result clicked'
    )
    sendGtmEvent(
      GtmTriggerName.SEARCH_BLOCK_NOTE_CLICK,
      'Block note result clicked'
    )
    onClick(SearchEntity.BLOCK_NOTE, block)
  }

  return (
    <div>
      {Object.keys(blocks).length > 0 && (
        <div>
          {!hideTitle && <div className={css.title}>Block Notes</div>}

          <div className={css.list}>
            {Object.entries(blocks).map(([id, block]) => (
              <div
                key={block.id}
                className={cx(css.item, {
                  [css.selected]: selectedItemId === id,
                })}
                onClick={handleClick(block)}
              >
                <div>{block.body}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default BlockNotes
